import React, { FC } from 'react'
import cx from 'classnames'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'

// import * as SC from './styled'

export type MarkdownTextProps = {
  className?: string
  text: string
}

const MarkdownText: FC<MarkdownTextProps> = (props) => {
  const { className, text } = props

  return (
    <div className={cx(className)}>
      <ReactMarkdown remarkPlugins={[remarkBreaks]}>{text}</ReactMarkdown>
    </div>
  )
}

export default MarkdownText
